import { all, call, put, spawn } from 'redux-saga/effects';
import addToTakeShape from './add-to-takeshape/saga.js';
import { agentEditorSaga } from './agent/slice.js';
import { aiEditorSaga } from './ai/slice.js';
import apiExplorer from './api-explorer/saga.js';
import assetPicker from './asset-picker/saga.js';
import assetUploader from './asset-uploader/saga.js';
import assets from './assets/saga.js';
import auth from './auth/saga.js';
import branches from './branches/saga.js';
import collab from './collab/saga.js';
import { context } from './config.js';
import confirm from './confirm/saga.js';
import content from './content/saga/index.js';
import contentList from './content-list/saga.js';
import { saga as contentPreview } from './content-preview/index.js';
import contentSearch from './content-search/saga.js';
import exportProject from './export/saga.js';
import formDialog from './form-dialog/saga.js';
import integrations from './integrations/saga.js';
import { saga as liveLinks } from './live-links/index.js';
import locales from './locales/saga.js';
import { showMessage } from './messages/actions.js';
import message from './messages/saga.js';
import { saga as netlifyAddon } from './netlify-addon/index.js';
import project from './project/saga.js';
import schedule from './schedule/saga.js';
import { schemaSaga as schema } from './schema/index.js';
import schemaForm from './schema-form/saga.js';
import service from './services/saga.js';
import staticSite from './sites/saga.js';
import sso from './sso/saga.js';
import userRole from './user-roles/saga.js';
import userTracking from './user-tracking/saga.js';
import version from './versions/saga.js';
import webhooks from './webhooks/saga.js';
import workbench from './workbench/saga.js';
import workflows from './workflows/saga.js';

export default function* root() {
  const sagas = {
    auth,
    collab,
    assets,
    assetUploader,
    project,
    schema,
    contentList,
    content,
    contentSearch,
    schemaForm,
    confirm,
    formDialog,
    staticSite,
    message,
    assetPicker,
    userTracking,
    webhooks,
    integrations,
    locales,
    liveLinks,
    netlifyAddon,
    service,
    version,
    userRole,
    workflows,
    schedule,
    sso,
    contentPreview,
    addToTakeShape,
    exportProject,
    apiExplorer,
    workbench,
    branches,
    agentEditorSaga,
    aiEditorSaga
  };

  yield all(
    Object.entries(sagas).map(([name, saga]) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (error) {
            if (context.tier === 'dev') {
              const message = `Uncaught Error in "${name}" Saga`;

              console.trace(message, error);
              yield put(showMessage('error', `${message}: "${error.message}" See console for more information.`));
            }
          }
        }
      })
    )
  );
}
